import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=35590141&"
import script from "./PropertyManagement.vue?vue&type=script&lang=js&"
export * from "./PropertyManagement.vue?vue&type=script&lang=js&"
import style0 from "./PropertyManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports